import { useEffect, useRef, useState } from "react"
import apis from "../../../api"
import { apiResult, formatDate, getUserSession } from "../../../Utils/Common"
import { Box, Paper, Typography } from "@mui/material"
import MemberCourseDailyCard from "./MemberCourseDailyCard"

const CourseRecords = (props)=> {
    const {category_id,classObj,memberCourse,date,onError,onLoaded,onHint,onMemberCourseUpdate} = props    
    const [ records,setRecords] = useState()
    const [hasRecord,setHasRecord] = useState(false)
    getUserSession(apis)
    const loadCourseRecord = ()=>{
        apis.courseRecordsGet(category_id,date.year,date.month).then((ret)=>{
            apiResult(ret,data=>{                
                setRecords(data)                
                onLoaded && onLoaded(data)
            },onError)
        })
    }
    useEffect(()=>{         
        category_id > 0 && loadCourseRecord()
    },[category_id,date?.year,date?.month])
    useEffect(()=>{        
        if(records) {
            for(let i=0;i<records.length;i++) {
                if(records[i].sdate == formatDate(date.date) && records[i].member_course_id == memberCourse?.member_course_id && records[i].class_id == classObj?.id) {
                    setHasRecord(true)
                    return
                }
            }
        }
        setHasRecord(false)
    },[records,memberCourse,classObj,date])
    const handleNew = (idx,record)=>{
        if(idx == -1) {
            loadCourseRecord()
        }else {
            let cc = [...records]
            cc[idx] = record
            setRecords(cc)
            onMemberCourseUpdate && onMemberCourseUpdate()
        }
    }
    let cardIdx = 0
    return <Box sx={{...props.sx}} > 
        {memberCourse && classObj && date && date.date && !hasRecord && <Paper sx={{p:1,mb:2}}>
            <Typography variant="subtitle1" sx={{mb:1,ml:1,color:"green",fontWeight:"bold"}}>Check in now!</Typography>    
            <MemberCourseDailyCard onNew={(item)=>{handleNew(-1,item)}} onHint={onHint} onError={onError} classObj={classObj} memberCourse={memberCourse} date={date} />
        </Paper>}
        <Typography variant="body2" sx={{mb:1,ml:1}}>All Course Records - {memberCourse?memberCourse.member?.name:"All members"}</Typography>
        {records && records.map((record,idx)=>{
            if((!memberCourse && classObj && record.class_id == classObj?.id) || (memberCourse && memberCourse.member_course?.id == record.member_course?.id)) {
                cardIdx++                                
                return <MemberCourseDailyCard  onNew={(item)=>{handleNew(idx,item)}} sx={{bgcolor:cardIdx%2 ==0 ?"#eee2":"#fff"}} key={idx} onHint={onHint} onError={onError} classObj={classObj} memberCourse={memberCourse} date={date} record={record}/>
            }
        })}
    </Box>
}
export default CourseRecords